import React, { useContext, useEffect, useState } from 'react';
import dayjs from "dayjs";
import { AiOutlineDown } from "react-icons/ai";
import { AiOutlineUp } from "react-icons/ai";
import good from '../../images/pic_w_good.png';
import bad from '../../images/pic_w_bad.png';
import DataContext from '../../ContextServer/DataContext';

function Common({ name }) {
    const {
        myData, setAirNode, setStinkNode, stdate, eddate, pageno, setMinwonSpot, setPositionXY
    } = useContext(DataContext);
    const [show, setShow] = useState(true);
    const [legend, setLegend] = useState(false);
    const [mean, setMean] = useState('0');
    const [unit, setUnit] = useState("㎍/㎥");
    const [grade, setGrade] = useState(0);

    const onClick = () => {
        setShow(!show);
    };
    // 평균값
    const getMean = (__name__) => {
        var sum = 0;
        var cnt = 0;
        if (__name__ === "초미세먼지") {
            { parseFloat(myData.pm25_val) }
        }
        else if (__name__ === "미세먼지") {
            { parseFloat(myData.pm10_val) }
        }
        else if (__name__ === "오존") {
            { parseFloat(myData.o3_val) };
        }

        var __mean__ = cnt ? sum / cnt : 0;
        setMean(__mean__);

    };

    const getGradeTextColor = (__grade__) => {
        if (__grade__ === 1 || __grade__ === "좋음") {
            return '#5c8cdd';
        }
        else if (__grade__ === 2 || __grade__ === "보통") {
            return '#65b24b';
        }
        else if (__grade__ === 3 || __grade__ === "나쁨") {
            return '#e2d058';
        }
        else if (__grade__ === 4 || __grade__ === "매우나쁨") {
            return '#ec7a7a';
        }

        return '#333';
    };
    let textColor = getGradeTextColor(grade);

    const gradeText = ["점검중", "좋음", "보통", "나쁨", "매우나쁨"];

    var gradeLabel = gradeText[grade];

    // 좋음/보통/...
    const nameChanged = (__name__) => {
        var __grade = grade;


        if (__name__ === "초미세먼지") {
            setUnit("㎍/㎥");
            __grade = parseInt(myData[0].pm25_grade);
            setGrade(__grade);
            gradeLabel = gradeText[__grade];
        } else if (__name__ === "미세먼지") {
            setUnit("㎍/㎥");
            __grade = parseInt(myData[0].pm10_grade);

            if (myData.length !== 0) {
                setGrade(__grade);
                gradeLabel = gradeText[__grade];
            }
        } else if (__name__ === "오존") {
            setUnit("ppm")
            __grade = parseInt(myData[0].o3_grade);
            setGrade(__grade);
            gradeLabel = gradeText[__grade];
        }
    };

    // 범례 데이터 가겨오기
    function getSelectedRange() {
        const pm25Range = ["0~15", "16~35", "36~75", "76~", "-"];
        const pm10Range = ["0~30", "31~80", "81~150", "151~", "-"];
        const o3Range = ["0~0.0300", "0.0310~0.0900", "0.0910~0.1500", "0.1510~", "-"];

        if (name === "초미세먼지") {
            return pm25Range;
        } else if (name === "미세먼지") {
            return pm10Range;
        } else if (name === "오존") {
            return o3Range;
        }
        return [];
    }
    const getData = () => {

        var sum = 0;
        var cnt = 0;

        if (name === "초미세먼지") {
            myData.map((item) => {
                sum += parseFloat(item.pm25_val);
                cnt++;
            });
            var __mean__ = cnt ? sum / cnt : 0;
            setMean(__mean__.toFixed(0));
        } else if (name === "미세먼지") {
            myData.map((item) => {
                sum += parseFloat(item.pm10_val);
                cnt++;
            });
            var __mean__ = cnt ? sum / cnt : 0;
            setMean(__mean__.toFixed(0));
        } else if (name === "오존") {
            myData.map((item) => {
                sum += parseFloat(item.o3_val);
                cnt++;
            });
            var __mean__ = cnt ? sum / cnt : 0;
            setMean(__mean__.toFixed(3));
        }

    };

    useEffect(() => {
        getData();
        setShow(true);
        nameChanged(name);
    }, []);

    return (
        <div className='common'>

            {/* 대기 평균값 */}
            <div className="najuAvr">
                <strong>나주시 평균</strong>
                <p>{myData[0]?.datetime}시 기준</p>
                <strong style={{ color: textColor }} >
                    {mean} {unit} {gradeLabel}
                </strong>
            </div>

            {/* 예보 */}
            <div className='forecastPreview'>
                <div className="foreTitle" onClick={onClick} >
                    <div className="foreTitleFlex">
                        <strong className="forecastStrong"> {name} 예보</strong>
                        <p>에어데이터 시간 기준</p>
                    </div>
                    <div className="icon" style={{ fontSize: "20px" }}>
                        {show ? <AiOutlineDown /> : <AiOutlineUp />}
                    </div>
                </div>
                <div className="modal" style={{ display: show ? "block" : "none" }}>

                    <table className="table" >
                        <tr className="date">
                            <th>어제</th>
                            <th>오늘</th>
                            <th>내일</th>
                        </tr>
                        <tr
                            className="box"
                            style={{
                                backgroundColor: "#ddd", textAlign: "center",
                            }}
                        >
                            <td className="img" >
                                <img src={good} alt="good" style={{ backgroundColor: getGradeTextColor(1), padding: 1, borderRadius: '50%' }} />
                            </td>
                            <td className="img" >
                                <img src={good} alt="good" style={{ backgroundColor: getGradeTextColor(1), padding: 1, borderRadius: '50%' }} />
                            </td>
                            <td className="img" >
                                <img src={good} alt="good" style={{ backgroundColor: getGradeTextColor(1), padding: 1, borderRadius: '50%' }} />
                            </td>
                        </tr>
                        <tr className="boxColor" >
                            <td > 좋음</td>
                            <td > 좋음</td>
                            <td > 좋음</td>
                        </tr>
                    </table>
                </div>
            </div>
            {/* 범례 */}
            <div className='legend'>

                <div className={legend ? "legendModal" : "none"}>
                    <table className='table'>
                        <thead >
                            <tr className='title'>
                                <th style={{ width: '45%', padding: '4px' }}>등급</th>
                                <th >지수범위</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className='box' style={{
                                textAlign: "center"
                            }}>
                                <td ><img src={good} alt="" style={{ backgroundColor: getGradeTextColor(1), padding: 1, borderRadius: '50%' }} /></td>
                                <td className='' >
                                    {getSelectedRange()[0]}
                                </td>
                            </tr>
                            <tr className='box' style={{ textAlign: "center" }}>
                                <td ><img src={good} alt="" style={{ backgroundColor: getGradeTextColor(2), padding: 1, borderRadius: '50%' }} /></td>
                                <td className='' >
                                    {getSelectedRange()[1]}
                                </td>
                            </tr>
                            <tr className='box' style={{ textAlign: "center" }}>
                                <td ><img src={bad} alt="" style={{ backgroundColor: getGradeTextColor(3), padding: 1, borderRadius: '50%' }} /></td>
                                <td className='' >
                                    {getSelectedRange()[2]}
                                </td>
                            </tr>
                            <tr className='box' style={{ textAlign: "center" }}>
                                <td ><img src={bad} alt="" style={{ backgroundColor: getGradeTextColor(4), padding: 1, borderRadius: '50%' }} /></td>
                                <td className=''>
                                    {getSelectedRange()[3]}
                                </td>
                            </tr>
                            <tr className='box' style={{ textAlign: "center" }}>
                                <td ><img src={bad} alt="" style={{ backgroundColor: getGradeTextColor(5), padding: 1, borderRadius: '50%' }} /></td>
                                <td className='' >
                                    {getSelectedRange()[4]}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className='legendTitle ' onClick={() => { setLegend(!legend) }} >
                    <div className='legendTitleFlex'>
                        <strong className="legendcastStrong">{name} 범례</strong>
                    </div>
                    <div className='icon' >
                        {legend ? <AiOutlineDown /> : <AiOutlineUp />}
                    </div>
                </div>
            </div >
        </div>
    );
}

export default Common;